import { Component } from 'react';

export default class FilterIcon extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.75 13.85">
            <g id="Layer_2" data-name="Layer 2">
                <g id="Layer_1-2" data-name="Layer 1">
                <path d="M0,3H13.83" fill="none" stroke="#2A3F49" stroke-width="1.5" />
                <path d="M6.92,10.88H20.75" fill="none" stroke="#2A3F49" stroke-width="1.5" />
                <circle cx="16.8" cy="2.97" r="2.22" fill="none" stroke="#2A3F49" stroke-width="1.5" />
                <circle cx="3.95" cy="10.88" r="2.22" fill="none" stroke="#2A3F49" stroke-width="1.5" />
                </g>
            </g>
            </svg>

        )
    }
};
